/** Static copy for Phase 1; replace with API response messages when wired. */
export const ROLE_TOAST_MESSAGES = {
  added: "Role successfully added.",
  updated: "Role successfully updated.",
  deleted: "Role successfully deleted.",
} as const;
